'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getClient = require('pobble-components/dist/api-client');
var Cookies = require('js-cookie');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var getClient__default = /*#__PURE__*/_interopDefaultLegacy(getClient);
var Cookies__default = /*#__PURE__*/_interopDefaultLegacy(Cookies);

var DEV_API_URL = Cookies__default["default"].get('dev_api_url');
var ENV = process.env.REACT_APP_ENV;

if (!ENV && !DEV_API_URL) {
  Cookies__default["default"].set('dev_api_url', "https://".concat(window.prompt('API url (without HTTPS)')));
  window.location.reload();
}

var API_ROOT = ENV ? "https://".concat(ENV === 'stg' ? "stg-" : '', "api.pobble.com/") : DEV_API_URL;
var client = getClient__default["default"]({
  baseUrl: API_ROOT
});

exports.apiClient = client;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src2416834937/src/pobble-app/client/~/pobble-components/dist/api/index.js